import { render } from "./modal-process-order.vue?vue&type=template&id=3d763903&scoped=true&ts=true"
import script from "./modal-process-order.vue?vue&type=script&lang=ts"
export * from "./modal-process-order.vue?vue&type=script&lang=ts"

import "./modal-process-order.vue?vue&type=style&index=0&id=3d763903&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d763903"]])

export default __exports__